import API from "../services/api";
import StorageService from "../services/general/storage";

const attribute = "users";

const Service = {
  validSecuritySession: () => {
    return new Promise((resolve, reject) => {
      if (Service.currentUser() === null) {
        reject();
      } else {
        resolve();
      }

    });
  },
  logout: () => {
    StorageService.delete('t');
    window.localStorage.clear();
  },
  authenticate: (username, password) => {
    return new Promise((resolve, reject) => {
      let item = { email: username, password: password };
      API.post('authenticate', [], item).then(
        result => {
          Service.setToken(result);
          Service.initLogin().then(
            (result) => { resolve(result) },
            (err) => { reject(err) }
          )
        },
        error => {
          reject(error);
        }
      );
    });
  },
  setToken: (token) => {
    StorageService.setString('t', token);
  },
  getToken: () => {
    return StorageService.getString('t');
  },
  initLogin: () => {
    return new Promise((resolve, reject) => {
      API.get('currentuser').then(
        result => {
          let current = result;

          current.menuitems = [
            { title: "Mijn werkbonnen", link: "workorders", icon: "workorders" }
          ]
          
          if (!current.adminmodules) { current.adminmodules = [] }
          if (current.adminmodules.find(mod => { return mod === 'clients' }) !== undefined) {
            current.menuitems.push({ title: "Klanten", link: "clients", icon: "clients" });
          }
          if (current.adminmodules.find(mod => { return mod === 'projects' }) !== undefined) {
            current.menuitems.push({ title: "Projecten", link: "projects", icon: "projects" });
          }
          if (current.adminmodules.find(mod => { return mod === 'users' }) !== undefined) {
            current.menuitems.push({ title: "Gebruikers", link: "users", icon: "users" });
          }
          if (current.adminmodules.find(mod => { return mod === 'workorders' }) !== undefined) {
            current.menuitems.push({ title: "Werkbonnen", link: "workordersadmin", icon: "workorders" });
          }
          if (current.adminmodules.find(mod => { return mod === 'accounting' }) !== undefined) {
            current.menuitems.push({ title: "Boekhouding", link: "accounting", icon: "attachmoney" });
          }
          current.menuitems.push({ title: "Kalender", link: "calendar", icon: "agenda" });
          if (current.adminmodules.find(mod => { return mod === 'settingsapp' }) !== undefined) {
            current.menuitems.push({ title: "Instellingen", link: "settings", icon: "settings" });
          }
          StorageService.setObject('currentuser', current);
          resolve(current);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  currentUser: () => {
    return StorageService.getObject('currentuser');
  },
  get: id => {
    return new Promise((resolve, reject) => {
      API.get(id ? attribute + "/" + id : attribute).then(
        result => {
          resolve(result);
          StorageService.setCollectionObject(attribute, id, result);
        },
        error => {
          StorageService.getCollectionObject(attribute, id)
            .then((foundStorage) => {
              resolve(foundStorage);
            }, (err) => {
              reject(error);
            })
        }
      );
    });
  },
  save: item => {
    return new Promise((resolve, reject) => {
      if (item._id) {
        API.post(attribute + "/" + item._id, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      } else {
        API.put(attribute, [], item).then(
          result => {
            resolve(result);
          },
          error => {
            reject(error);
          }
        );
      }
    });
  },
  delete: id => {
    return new Promise((resolve, reject) => {
      API.deleteItem(attribute + "/" + id).then(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  sendSecurityCode: email => {
    return new Promise((resolve, reject) => {
      API.get(attribute, null, 'requestsecuritycode=true&email=' + email).then(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  setNewPassword: (email, securitycode, newpassword) => {
    return new Promise((resolve, reject) => {
      API.post('changepassword', null, { email: email, securitycode: securitycode, newpassword: newpassword }).then(
        result => {
          resolve(result);
        },
        error => {
          reject(error);
        }
      );
    });
  },
  getFunction: (type) => {
    switch (type) {
      case 0:
        return '';
        break;
      case 1:
        return 'Personeel';
        break;
      case 2:
        return 'Uitzendkracht';
        break;
      case 3:
        return 'ZZP-er';
        break;
      default:
        return '';
        break;
    }
  }
};
export default Service;
